<template>
  <div class="searchWrapper">
    <div class="icon"><SearchIcon /></div>
    <input
      type="text"
      autocomplete="off"
      :placeholder="$t('searchField.inputPlaceholder')"
      name="search"
      v-model="text"
    />
    <!-- <v-btn @click="search" :disabled="searching" class="searchBtn">хайх</v-btn> -->
  </div>
</template>

<script>
import SearchIcon from "../components/icons/SearchIcon";
export default {
  name: "SearchField",
  data: () => ({
    list: null,
    text: "",
  }),
  props: {
    searchFolder: { type: Function },
    clearedField: { type: Function },
    searching: { type: Boolean },
  },
  components: {
    SearchIcon,
  },
  watch: {
    text: function() {
      if (this.text.length > 1) {
        this.searchFolder(this.text);
      } else if (this.text.length === 0) {
        this.clearedField();
      }
    },
  },
  methods: {
    search() {
      this.searchFolder(this.text);
    },
  },
};
</script>

<style scoped>
.searchWrapper {
  display: flex;
  position: relative;
  width: 278px;
  height: 40px;
}
.searchWrapper input[type="text"] {
  /* height: 40px; */
  padding-left: 40px;
  padding-right: 80px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  transition: 0.4s ease-out;
}

.searchWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.searchWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.icon {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 11px;
  left: 11px;
}

.searchBtn {
  position: absolute;
  right: 5px;
  top: 5px;
  box-shadow: none;
  height: 30px !important;
  background-color: #777ff6 !important;
  color: white;
  font-size: 14px;
  text-transform: initial;
}

.example::after {
  content: "";
  clear: both;
  display: table;
}
</style>
